import { Login } from '@/modules/account';
import { useStore } from '@/store';

import { observer } from 'mobx-react-lite';
import { Outlet } from 'react-router-dom';

const ProtectedRoute = observer(() => {
  const { accountStore } = useStore();
  const isAuthenticated = Boolean(accountStore.accountData._id);

  return isAuthenticated ? <Outlet /> : <Login />;
});

export default ProtectedRoute;
